import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useHouseholdRelationshipChartsDataContext } from './hooks/useHouseholdRelationshipChartsDataContext';

export const KnowAboutMother = () => {
    const { chartData } = useHouseholdRelationshipChartsDataContext();

    return (
        <Donut
            title={'Conhecimento sobre a Mãe'}
            subtitles={chartData?.knowAboutMother?.map((item) => item.description)}
            chartData={chartData?.knowAboutMother || []}
            colors={defaultColors.slice(0, chartData?.knowAboutMother?.length) || []}
            height={350}
        />
    );
};
